import fc from "@/firebaseConfig";
import { INVOICE_STATUS } from "@/libs/libConstant";
export default {
  namespaced: true,
  state: {
    expenseList: [],
    payAcctList: [],
    whtList: [],
    vatList: [],
    purchaseInvoices: [],
    currentPage: 1,
    itemsPerPage: 10,
    isLoading: false,
    unsubscribePurchaseInvoices: null,
  },
  mutations: {
    SET_EXPENSE_LIST(state, expenses) {
      state.expenseList = expenses;
    },
    SET_PAY_ACCT_LIST(state, accounts) {
      state.payAcctList = accounts;
    },
    SET_WHT_LIST(state, whtItems) {
      state.whtList = whtItems;
    },
    SET_VAT_LIST(state, vatItems) {
      state.vatList = vatItems;
    },
    SET_PURCHASE_INVOICES(state, invoices) {
      state.purchaseInvoices = invoices;
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_ITEMS_PER_PAGE(state, limit) {
      state.itemsPerPage = limit;
    },
    SET_LOADING(state, val) {
      state.isLoading = val;
    },
    SET_UNSUBSCRIBE_PURCHASE_INVOICES(state, fn) {
      state.unsubscribePurchaseInvoices = fn;
    },
  },
  actions: {
    fetchExpenseList({ commit }, { companyId }) {
      fc.db
        .collection(`/Companies/${companyId}/PurchaseInvoiceMaster`)
        .doc("Expense")
        .get()
        .then((snapshot) => {
          const expenses = snapshot.data()?.data || [];
          commit("SET_EXPENSE_LIST", expenses);
        })
        .catch((error) => {
          console.error("Error fetchExpenseList:", error);
        });
    },
    fetchPayAcctList({ commit }, { companyId }) {
      fc.db
        .collection(`/Companies/${companyId}/PurchaseInvoiceMaster`)
        .doc("PaymentAccount")
        .get()
        .then((snapshot) => {
          const payAct = snapshot.data()?.data || [];
          commit("SET_PAY_ACCT_LIST", payAct);
        })
        .catch((error) => {
          console.error("Error fetchPayAcctList:", error);
        });
    },
    fetchWhtList({ commit }, { companyId }) {
      fc.db
        .collection(`/Companies/${companyId}/PurchaseInvoiceMaster`)
        .doc("WithholdingTax")
        .get()
        .then((snapshot) => {
          const wht = snapshot.data()?.data || [];
          commit("SET_WHT_LIST", wht);
        })
        .catch((error) => {
          console.error("Error fetchWhtList:", error);
        });
    },
    fetchVatList({ commit }, { companyId }) {
      fc.db
        .collection(`/Companies/${companyId}/PurchaseInvoiceMaster`)
        .doc("Vat")
        .get()
        .then((snapshot) => {
          const vat = snapshot.data()?.data || [];
          commit("SET_VAT_LIST", vat);
        })
        .catch((error) => {
          console.error("Error fetchVatList:", error);
        });
    },
    async fetchPurchaseInvoices(
      { commit, state },
      {
        companyId,
        vendorID,
        searchColumn = "docId",
        keyword,
        keywordFromDate,
        keywordToDate,
        statusFilter,
      }
    ) {
      commit("SET_LOADING", true);

      // Unsubscribe previous listener if exists
      if (state.unsubscribePurchaseInvoices) {
        state.unsubscribePurchaseInvoices();
        commit("SET_UNSUBSCRIBE_PURCHASE_INVOICES", null);
      }

      const defaultSt = [
        "FAILURE",
        "CONFIRMED",
        "PENDING_APPROVAL",
        "POSTING",
        "WARNING",
        "ERROR",
      ];
      const st =
        statusFilter && searchColumn === "status"
          ? statusFilter === "SHOW_ALL"
            ? defaultSt
            : [statusFilter]
          : defaultSt;

      let ref = fc.db
        .collection(`Companies/${companyId}/PurchaseInvoices`)
        .where("status", "in", st);
      if (vendorID) ref = ref.where("CompanyCode", "==", vendorID);
      if (keyword && searchColumn === "docId") {
        ref = ref
          .where(searchColumn, ">=", keyword)
          .where(searchColumn, "<=", keyword + "\uf8ff");
      }
      if (keywordFromDate && searchColumn === "docDate") {
        const start = new Date(keywordFromDate);
        start.setHours(0);
        const end = new Date(keywordToDate || keywordFromDate);
        end.setHours(23, 59, 59, 999);
        ref = ref
          .where(searchColumn, ">=", start)
          .where(searchColumn, "<=", end);
      }

      // Set up realtime listener
      const unsubscribe = ref.orderBy(searchColumn).onSnapshot(
        (snapshot) => {
          const invoices = snapshot.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }));
          commit("SET_PURCHASE_INVOICES", invoices);
          commit("SET_LOADING", false);
        },
        (err) => {
          console.error("Realtime listener error:", err);
          commit("SET_LOADING", false);
        }
      );

      commit("SET_UNSUBSCRIBE_PURCHASE_INVOICES", unsubscribe);
    },
  },
};
